import _dict from '../lib/a_dictionary.js';

export const lang = {};

lang.languages = [
    {
        name: 'English',
        code: 'en',
        adjective: 'before',
    },
    {
        name: 'Danish',
        code: 'da',
        adjective: 'before',
    },
    {
        name: 'French',
        code: 'fr',
        adjective: 'after',
    },
    {
        name: 'Romanian',
        code: 'ro',
        adjective: 'after',
    },
];

// set in development only, otherwise set to null
lang.overrideLanguage = null

lang.currentLanguage = lang.overrideLanguage || (() => {
    if (typeof navigator === 'undefined') return 'en';
    if (navigator.languages === undefined) return 'en';
    if (navigator.languages[0] === undefined) return 'en';
    if (typeof navigator.languages[0] !== 'string') return 'en';

    const myLang = navigator.languages[0].substring(0, 2);
    if (!myLang) return 'en';
    const myEntry = lang.languages.find(element => element.code === myLang);
    if (myEntry === undefined) return 'en';

    return myEntry;
})();

lang.get = (desc, defaultStr=null) => {
    if (defaultStr === null) defaultStr = desc;
    const myEntry = _dict.find(element => element.desc == desc);
    const result = myEntry ? myEntry[lang.currentLanguage.code] : null;
    return result || defaultStr;
};

lang.caps = (str, locale=lang.currentLanguage.code) => str.replace(/^\p{CWU}/u, char => char.toLocaleUpperCase(locale));

export const caps = lang.caps;

lang.translateApp = () => {

    // Translate hover titles for Trix plugin

    document.getElementsByClassName('trix-button--icon-heading-1')[0].title = lang.get('word chart format button: heading', 'Heading');
    document.getElementsByClassName('trix-button--icon-bold')[0].title = lang.get('word chart format button: bold', 'Bold');

};
